import { Component, OnInit } from '@angular/core';
import { TramitesService } from 'src/app/servicios/tramites.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Loading } from 'src/app/Class/Loading';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/servicios/user.service';

@Component({
  selector: 'app-crear',
  templateUrl: './crear.component.html',
  styleUrls: ['./crear.component.css']
})
export class CrearTramitesComponent implements OnInit {
  public formTipoTramite: FormGroup;
  public descripcionckeditor = "";
  public unidades_organizativas: any = [];
  public programas: any = [];
  public facultades: any = [];
  public estamentos: any = [];
  public clasificaciones: any = [];
  public id:any;

  constructor(public rout: ActivatedRoute, public router: Router, private tipoTramiteService: TramitesService,  private fb: FormBuilder, public loading: Loading, public user: UserService) {
    this.loading.estado = true;  
    this.rout.params.subscribe(params => { this.id = params['id']; });
    
    if(this.id!=undefined){
      
      this.tipoTramiteService.getDetalleTramite(this.id).subscribe(data => {
        if (data['success']) {
          
          for ( const atributos  in this.formTipoTramite.value) {
            this.formTipoTramite.get(atributos).setValue(data['formTipoTramite'][atributos]);
          }
          this.descripcionckeditor = this.formTipoTramite.value['descripcion'];
        } 
        else {
          Swal.fire({ type: 'warning', title: 'No existe ese trámite', showConfirmButton: false, timer: 1500 });
        }
        this.loading.estado = false;
        });
    }
       
     
    
    const reg = "(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$";
    
     this.tipoTramiteService.getDatosSelect()
    .subscribe(data => {
      this.unidades_organizativas = data['data']['unidades_organizativas'];
      this.programas = data['data']['programas'];
      this.facultades = data['data']['facultades'];
      this.estamentos = data['data']['estamentos'];
      this.clasificaciones = data['data']['clasificaciones'];
    

      this.loading.estado = false;
    });  
    this.formTipoTramite = this.fb.group({
      id: [],
      nombre: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(149)]],
      abreviatura: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(5)]],
      dias_tramite: [],
      //dias_habiles: [],
      descripcion: [],
      estamentos_selected: [],
      programas_selected: [],
      facultades_selected: [],
      unidades_organizativas_selected: [],
      clasificaciones_selected: [],
      link_pago: [, [Validators.pattern(reg)]],
      url_siut: [, [Validators.pattern(reg)]],
      secretaria_general: [false],
      gratuito: [],
    });
   }
   
  guardarTipoTramite() {
    
    this.loading.estado = true;
    if( this.formTipoTramite.value['gratuito'] == null) this.formTipoTramite.value['gratuito']=false;
    this.formTipoTramite.value['descripcion'] = this.descripcionckeditor;
    this.tipoTramiteService.guardarTipoTramite(this.formTipoTramite.value)
        .subscribe(data => {
          if (data['success']) {
            Swal.fire({ type: 'success', title: 'Guardado exitoso', showConfirmButton: false, timer: 1500 });
            this.router.navigate(['/tramites/tipoTramites/']);
          } else {
            Swal.fire({ type: 'warning', title: 'No se pudo completar la solicitud', showConfirmButton: false, timer: 1500 });
          }
          this.loading.estado = false;
    });
  }


  ngOnInit() {
  }

}
